export default {
  MONTH: 'MONTH',
  DAY: 'DAY',
  WEEK: 'WEEK',
} as const;
